<div class="wrapper-billing" [class.embedded]="embedded" [ngClass]="{ 'is-loading': loading }">
  <div class="section-title" *ngIf="!embedded">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Orders" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="checkout-toolbar mb-4" [class.is-collapsed]="!toolbarOpen">
    <div class="filter-options" id="ordersFilterOptions">
      <!-- Date Filter Dropdown -->
      <div ngbDropdown #dateDropdown="ngbDropdown" class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="dateFilter?.value !== 'cm' || (fromDate && toDate)"
          id="dropdownDateFilter"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-calendar mr-1"></i>
          <span>
            {{ (orders.type?.display | translate) || (dateFilter?.display | translate) || ("Order Date" | translate) }}
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownDateFilter" class="custom-dropdown p-2" style="min-width: 260px;">
          <button ngbDropdownItem *ngFor="let filter of DATE_FILTERS" [disabled]="filter.selectable"
            (click)="dateFilter = filter; datePeriod()">
            {{ "{0}" | translate : [utils.translate(filter.display)] }}
          </button>
          <div class="dropdown-divider"></div>
          <div class="px-2 date-range-picker">
            <p class="mb-2 font-weight-bold text-xs">{{ "Select a date range" | translate }}:</p>
            <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="1"
              [minDate]="this.minDate" [maxDate]="this.maxDate" [dayTemplate]="t" outsideDays="hidden">
            </ngb-datepicker>

            <ng-template #t let-date let-focused="focused">
              <div class="custom-day-container" [class.focused]="focused" [class.start-day]="date == fromDate"
                [class.end-day]="date == toDate" [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                <span class="custom-day">{{ date.day }}</span>
              </div>
            </ng-template>
            <div class="py-2 text-right">
              <button type="button" class="btn btn-date-range cancel mr-1" (click)="dateDropdown.close()">
                {{ "Cancel" | translate }}
              </button>
              <button type="button" class="btn btn-date-range" [disabled]="!fromDate || !toDate"
                (click)="dateDropdown.close(); setDueDate()">
                {{ "Apply" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Express Checkout Link Filter Dropdown -->
      <div ngbDropdown class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="selectedExpressCheckoutLink?.value !== 'ALL'"
          id="dropdownExpressCheckout"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-link mr-1"></i>
          <span>
            {{ getSelectedExpressCheckoutDisplay() | translate }}
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownExpressCheckout" class="custom-dropdown express-checkout-menu shadow-md">
          <div class="px-3 py-2 border-bottom search-link-box" *ngIf="availableCheckoutLinks?.length > 3">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm pr-4" 
                [(ngModel)]="checkoutLinkSearchText" 
                placeholder="{{ 'Search checkout link...' | translate }}"
                (click)="$event.stopPropagation()" />
              <i class="fi fi-rr-search position-absolute text-muted" style="right: 8px; top: 7px; font-size: 12px;"></i>
            </div>
          </div>

          <div class="dropdown-links-list">
            <button ngbDropdownItem [class.active]="selectedExpressCheckoutLink?.value === 'ALL'" 
              (click)="selectExpressCheckoutFilter({ display: 'All Orders', value: 'ALL' })">
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>{{ "All Orders" | translate }}</span>
                <i class="fi fi-rr-check text-primary" *ngIf="selectedExpressCheckoutLink?.value === 'ALL'"></i>
              </div>
            </button>

            <button ngbDropdownItem [class.active]="selectedExpressCheckoutLink?.value === 'EXPRESS_ALL'" 
              (click)="selectExpressCheckoutFilter({ display: 'Express Checkout Orders', value: 'EXPRESS_ALL' })">
              <div class="d-flex align-items-center justify-content-between w-100">
                <span>{{ "Express Checkout Orders" | translate }}</span>
                <i class="fi fi-rr-check text-primary" *ngIf="selectedExpressCheckoutLink?.value === 'EXPRESS_ALL'"></i>
              </div>
            </button>

            <div class="dropdown-divider my-1"></div>

            <div class="dropdown-header text-uppercase text-muted font-weight-bold px-3 py-1 text-xs">
              {{ "Available Checkout Links" | translate }} ({{ getFilteredCheckoutLinkOptions()?.length || 0 }})
            </div>

            <button ngbDropdownItem 
              *ngFor="let link of getFilteredCheckoutLinkOptions()" 
              [class.active]="selectedExpressCheckoutLink?.value === link.id" 
              (click)="selectExpressCheckoutFilter({ display: link.displayTitle || link.title, title: link.title, value: link.id })">
              <div class="d-flex flex-column w-100 py-1">
                <div class="d-flex align-items-center justify-content-between">
                  <span class="font-weight-medium text-truncate link-title" [title]="link.displayTitle || link.title">
                    {{ link.displayTitle || link.title }}
                  </span>
                  <i class="fi fi-rr-check text-primary ml-2" *ngIf="selectedExpressCheckoutLink?.value === link.id"></i>
                </div>
                <span class="text-muted text-truncate link-subtext" *ngIf="link.url && link.displayTitle !== link.url">
                  {{ link.url }}
                </span>
              </div>
            </button>

            <div class="text-center py-2 text-muted text-xs" *ngIf="getFilteredCheckoutLinkOptions()?.length === 0">
              {{ "No checkout links found" | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- Payment and platform filters; order status is the tabs above the list -->
      <div
        ngbDropdown
        #moreFilters="ngbDropdown"
        class="d-inline-block"
        autoClose="outside"
        placement="bottom-left bottom-right"
        *ngIf="hasMoreFilters"
      >
        <button
          type="button"
          class="btn btn-filter btn-more-filters"
          [class.active]="moreFilterCount > 0"
          id="dropdownMoreFilters"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-settings-sliders mr-1"></i>
          <span>{{ "More filters" | translate }}</span>
          <span class="filter-count" *ngIf="moreFilterCount > 0">{{ moreFilterCount }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownMoreFilters" class="more-filters-menu">
          <section class="filter-group" *ngIf="showFilterGroup(paymentStatusFilters, selectedPaymentStatus)">
            <h5 class="filter-group-title" id="filterPaymentStatus">{{ "Payment Status" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterPaymentStatus">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of paymentStatusFilters"
                [class.active]="isSelectedFilter(selectedPaymentStatus, filter)"
                [attr.aria-checked]="isSelectedFilter(selectedPaymentStatus, filter)"
                (click)="selectedPaymentStatus = filter; paginationPage = 1"
              >
                {{ filter.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>

          <section class="filter-group" *ngIf="showFilterGroup(paymentTypeFilters, selectedPaymentType)">
            <h5 class="filter-group-title" id="filterPaymentMethod">{{ "Payment Method" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterPaymentMethod">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of paymentTypeFilters"
                [class.active]="isSelectedFilter(selectedPaymentType, filter)"
                [attr.aria-checked]="isSelectedFilter(selectedPaymentType, filter)"
                (click)="selectedPaymentType = filter; paginationPage = 1"
              >
                {{ filter.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>

          <section class="filter-group" *ngIf="showFilterGroup(platformTypeFilters, selectedPlatformType)">
            <h5 class="filter-group-title" id="filterPlatform">{{ "Platform" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterPlatform">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of platformTypeFilters"
                [class.active]="isSelectedFilter(selectedPlatformType, filter)"
                [attr.aria-checked]="isSelectedFilter(selectedPlatformType, filter)"
                (click)="selectedPlatformType = filter; paginationPage = 1"
              >
                {{ filter.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>

          <div class="more-filters-footer">
            <button type="button" class="btn filter-clear" [disabled]="moreFilterCount === 0" (click)="clearMoreFilters()">
              {{ "Clear" | translate }}
            </button>
            <button type="button" class="btn btn-primary filter-done" (click)="moreFilters.close()">
              {{ "Done" | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Direct Export Excel Button -->
      <button
        type="button"
        class="btn btn-filter btn-export-excel"
        (click)="download('excel')"
        [disabled]="!filteredOrderHistoryList?.length || isExporting"
        title="{{ 'Export to Excel' | translate }}"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1.5 flex-shrink-0">
          <path fill="#107C41" d="M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2Z"/>
          <path fill="#FFFFFF" opacity="0.6" d="M14 2L20 8H14V2Z"/>
          <path fill="#FFFFFF" d="M9.6 16.5L11.5 13.6L13.4 16.5H15.5L12.6 12.3L15.3 8.5H13.2L11.5 11L9.8 8.5H7.7L10.4 12.3L7.5 16.5H9.6Z"/>
        </svg>
        <span class="text-[#107C41] font-weight-medium" *ngIf="!isExporting">{{ "Export Excel" | translate }}</span>
        <span class="text-[#107C41] font-weight-medium" *ngIf="isExporting">{{ "Retrieving...please wait" | translate }}</span>
      </button>
    </div>

    <!-- Search; on phones the filters above fold behind the Filters button beside it -->
    <div class="toolbar-end">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="orderId"
          (change)="searchOrder($event)"
          (keyup.enter)="searchOrder($event)"
          placeholder="{{ 'Search Order ID' | translate }}"
        />
        <i class="fi fi-rr-search search-icon"></i>
        <i class="fas fa-times clear-icon" *ngIf="orderId" (click)="clearOrderSearch()"></i>
      </div>
      <button
        type="button"
        class="btn toolbar-toggle"
        [class.active]="toolbarFilterCount > 0"
        [class.is-open]="toolbarOpen"
        [attr.aria-expanded]="toolbarOpen"
        aria-controls="ordersFilterOptions"
        (click)="toolbarOpen = !toolbarOpen"
      >
        <i class="fi fi-rr-filter" aria-hidden="true"></i>
        <span>{{ "Filters" | translate }}</span>
        <span class="filter-count" *ngIf="toolbarFilterCount > 0">{{ toolbarFilterCount }}</span>
        <i class="fi fi-rr-angle-small-down toggle-chevron" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <!-- Orders waiting for the dealer's approval (cash on delivery, self collect) -->
  <div
    class="approval-banner"
    *ngIf="pendingOrderCloseBtn || pendingApprovalCount > 0"
    [class.is-filtering]="pendingOrderCloseBtn"
  >
    <span class="approval-banner-icon" aria-hidden="true">
      <i class="fi fi-rr-time-past"></i>
    </span>
    <div class="approval-banner-text">
      <ng-container *ngIf="!pendingOrderCloseBtn; else filteringPending">
        <p class="approval-banner-title">
          {{
            pendingApprovalCount === 1
              ? ("1 order is waiting for your approval" | translate)
              : ("{0} orders are waiting for your approval" | translate : [pendingApprovalCount])
          }}
        </p>
        <p class="approval-banner-hint">
          {{ "Cash on delivery and self-collect orders are sent for fulfilment only after you approve them." | translate }}
        </p>
        <!-- Meta merges the browser and server Purchase for an order only
             within ~48h; approval is when the server one is sent. -->
        <p class="approval-banner-hint">
          {{ "Approve within 48 hours of the order so Meta counts each sale once in your ad reports." | translate }}
          <strong *ngIf="overdueApprovalCount > 0">
            {{
              overdueApprovalCount === 1
                ? ("1 of them is over 48 hours old and may be counted twice in Meta." | translate)
                : ("{0} of them are over 48 hours old and may be counted twice in Meta." | translate : [overdueApprovalCount])
            }}
          </strong>
        </p>
      </ng-container>
      <ng-template #filteringPending>
        <p class="approval-banner-title">{{ "Showing orders waiting for your approval" | translate }}</p>
      </ng-template>
    </div>
    <button
      *ngIf="!pendingOrderCloseBtn"
      type="button"
      class="btn approval-banner-btn"
      (click)="selectPendingOrder()"
    >
      {{ "Review orders" | translate }}
    </button>
    <button
      *ngIf="pendingOrderCloseBtn"
      type="button"
      class="btn approval-banner-btn is-quiet"
      (click)="resetPendingOrder()"
    >
      <i class="fi fi-rr-cross-small"></i>
      {{ "Show all orders" | translate }}
    </button>
  </div>

  <div class="section-main">
    <div class="row" *ngIf="dataIsLoading; else loadedContent">
      <div class="loading-spinner col-12 mt-5">
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <ng-template #loadedContent>
      <div class="orders-panel">
        <!-- Order status: one tab per status, each with its order count -->
        <div
          class="status-tabs"
          role="tablist"
          [attr.aria-label]="'Order Status' | translate"
          *ngIf="allOrderList?.length"
        >
          <button
            type="button"
            role="tab"
            class="status-tab"
            *ngFor="let tab of statusTabs"
            [class.active]="isSelectedFilter(selectedStatus, tab.option)"
            [class.is-approval]="tab.option.value === 'Waiting Approval'"
            [class.is-zero]="!tab.count"
            [attr.aria-selected]="isSelectedFilter(selectedStatus, tab.option)"
            (click)="selectStatusTab(tab.option)"
          >
            <span>
              {{ tab.option.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(tab.option.display)]) }}
            </span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <div class="orders-empty" *ngIf="!filteredOrderHistoryList?.length">
          <img class="orders-empty-image" src="/assets/empty-box.png" alt="" />
          <h3>{{ "No Order Found" | translate }}</h3>
          <p>
            {{ "We couldn't find any order data for the selected filter." | translate }}
            <br />
            {{ "Try change the filter?" | translate }}
          </p>
        </div>

        <ng-container *ngIf="filteredOrderHistoryList?.length">
          <div class="orders-head" aria-hidden="true">
            <span>{{ "Order" | translate }}</span>
            <span>{{ "Customer" | translate }}</span>
            <span>{{ "Status" | translate }}</span>
            <span class="text-right">{{ "Total" | translate }}</span>
            <span></span>
          </div>

          <div
            class="order-row"
            *ngFor="let data of filteredOrderHistoryList; let index = index"
            [class.is-pending]="isPendingApproval(data)"
            (click)="openOrderFromRow(content, index)"
          >
            <!-- Order ID, platform (when not the default store) and date -->
            <div class="order-cell order-main">
              <div class="order-id-line">
                <button
                  type="button"
                  class="order-id"
                  [attr.aria-label]="('Order Details' | translate) + ' #' + getOrderId(data)"
                  (click)="$event.stopPropagation(); openModal(content, index)"
                >
                  #{{ getOrderId(data) }}
                </button>
                <span class="platform-tag" *ngIf="getOrderType(data.platform)?.display !== 'Default'">
                  {{ getOrderType(data.platform)?.display | translate }}
                </span>
              </div>
              <span
                class="order-date"
                #tooltip="matTooltip"
                [matTooltip]="data.created | date : 'medium'"
                matTooltipPosition="above"
                matTooltipHideDelay="100"
              >
                {{ data.created | timeago : true }}
              </span>
            </div>

            <div class="order-cell order-customer">
              <i class="fi fi-rr-user customer-icon" aria-hidden="true"></i>
              <span class="order-customer-name" [title]="data.receiver_name">{{ data.receiver_name || "-" }}</span>
            </div>

            <div class="order-cell order-status">
              <div class="status-chips">
                <!-- Older API without the split labels: keep the single status. -->
                <span *ngIf="!data.order_status_label" class="status-chip" [ngClass]="getStatus(data.status)?.class">
                  {{ getStatus(data.status)?.display | translate : [utils.translate(data.status)] }}
                </span>
                <ng-container *ngIf="data.order_status_label">
                  <span
                    class="status-chip"
                    [ngClass]="getOrderStatusClass(data.order_status_label)"
                    [title]="getOrderStatusHint(data.order_status_label)"
                  >
                    <span class="chip-key">{{ "Order" | translate }}</span>
                    {{ data.order_status_label | translate }}
                  </span>
                  <span
                    class="status-chip"
                    [ngClass]="getPaymentStatusClass(data.payment_status_label)"
                    [title]="getPaymentStatusHint(data.payment_status_label)"
                  >
                    <span class="chip-key">{{ "Payment" | translate }}</span>
                    {{ data.payment_status_label | translate }}
                  </span>
                </ng-container>
              </div>
              <span class="payment-method" *ngIf="getPaymentType(data.payment_type)?.display">
                <i class="fi fi-rr-wallet" aria-hidden="true"></i>
                {{ getPaymentType(data.payment_type)?.display | translate }}
              </span>
            </div>

            <div class="order-cell order-total">
              {{ data.currency }} {{ data.total_price | number }}
            </div>

            <div class="order-cell order-actions" (click)="$event.stopPropagation()">
              <ng-container *ngIf="isPendingApproval(data)">
                <button type="button" class="btn row-btn row-btn-approve" [disabled]="loading" (click)="confirmApproveCod(data)">
                  <i class="fi fi-rr-check" aria-hidden="true"></i>
                  {{ "Approve" | translate }}
                </button>
                <button
                  type="button"
                  class="btn row-btn row-btn-danger"
                  [disabled]="loading"
                  (click)="rejectCod(data, rejectCodTemplate)"
                >
                  <i class="fi fi-rr-cross-small" aria-hidden="true"></i>
                  {{ "Reject" | translate }}
                </button>
              </ng-container>
              <button
                *ngIf="data?.payment_type === 'subscription' && data?.payment_status === 1"
                type="button"
                class="btn row-btn row-btn-danger"
                [disabled]="loading"
                (click)="cancelSubscription(data?.store_order_id)"
              >
                {{ "Cancel" | translate }}
              </button>
              <button *ngIf="data?.o_id && !isCompanyStore" type="button" class="row-link" (click)="viewOnFiv5()">
                {{ buttonLabel | translate }}
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" fill="currentColor" />
                </svg>
              </button>
              <button
                type="button"
                class="row-open"
                [attr.aria-label]="'Order Details' | translate"
                [title]="'Order Details' | translate"
                (click)="openModal(content, index)"
              >
                <i class="fi fi-rr-angle-small-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <div class="row px-4 py-3 pagination" *ngIf="filteredOrderHistoryList?.length != 0 && !dataIsLoading">
      <div class="col-lg-3 flex">
        <ngb-pagination [collectionSize]="totalRecord" [(page)]="paginationPage" [pageSize]="paginationPageSize"
          aria-label="Default pagination" [ellipses]="false" [rotate]="true" (pageChange)="changePage($event)"
          [maxSize]="5"></ngb-pagination>
      </div>
      <div class="col-lg-3 lg-center paginationWrapper" *ngIf="filteredOrderHistoryList?.length">
        <div class="mt-2 text-center">
          {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
          <b>{{ totalRecord }}</b>
        </div>
      </div>
      <div class="col-lg-4"></div>
    </div>

    <ng-template #content let-modal>
      <div class="order-details">
        <!-- Header: the order's IDs and where it stands -->
        <div class="od-header">
          <div class="od-heading">
            <h2 class="od-title" id="modal-basic-title">{{ "Order Details" | translate }}</h2>
            <p class="od-ids">
              <span *ngIf="selectedOrderHistory?.o_id">
                {{ "Order ID" | translate }} <strong>#{{ selectedOrderHistory?.o_id }}</strong>
              </span>
              <span *ngIf="selectedOrderHistory?.store_order_id">
                {{ "Platform Order ID" | translate }} <strong>{{ selectedOrderHistory?.store_order_id }}</strong>
              </span>
            </p>
            <div class="od-status">
              <!-- Older API without the split labels: keep the single status. -->
              <span
                *ngIf="!selectedOrderHistory?.order_status_label"
                class="status-chip"
                [ngClass]="getStatus(selectedOrderHistory?.status)?.class"
              >
                {{ getStatus(selectedOrderHistory?.status)?.display | translate }}
              </span>
              <span
                *ngIf="selectedOrderHistory?.order_status_label"
                class="status-chip"
                [ngClass]="getOrderStatusClass(selectedOrderHistory?.order_status_label)"
                [title]="getOrderStatusHint(selectedOrderHistory?.order_status_label)"
              >
                <span class="chip-key">{{ "Order" | translate }}</span>
                {{ selectedOrderHistory?.order_status_label | translate }}
              </span>
              <span
                *ngIf="selectedOrderHistory?.payment_status_label"
                class="status-chip"
                [ngClass]="getPaymentStatusClass(selectedOrderHistory?.payment_status_label)"
                [title]="getPaymentStatusHint(selectedOrderHistory?.payment_status_label)"
              >
                <span class="chip-key">{{ "Payment" | translate }}</span>
                {{ selectedOrderHistory?.payment_status_label | translate }}
              </span>
            </div>
          </div>
          <button type="button" class="od-close" [attr.aria-label]="'Close' | translate" (click)="modal.dismiss('Cross click')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>

        <!-- Tabs, only when there is a second one (subscriptions) -->
        <div class="od-tabs" role="tablist" *ngIf="isSubscription(selectedOrderHistory)">
          <button type="button" role="tab" class="od-tab" [class.active]="isCurrentDetailsTab(0)"
            [attr.aria-selected]="isCurrentDetailsTab(0)" (click)="changeDetailsTab(0)">
            {{ "Order Summary" | translate }}
          </button>
          <button type="button" role="tab" class="od-tab" [class.active]="isCurrentDetailsTab(1)"
            [attr.aria-selected]="isCurrentDetailsTab(1)" [disabled]="!selectedOrderHistory?.recurred_order?.length"
            (click)="changeDetailsTab(1)">
            {{ "Subscription Cycle" | translate }}
          </button>
        </div>

        <div class="od-body">
          <ng-container *ngIf="isCurrentDetailsTab(0)">
            <!-- Key facts -->
            <dl class="od-facts">
              <div class="od-fact od-fact-total">
                <dt>{{ "Order Total" | translate }}</dt>
                <dd>{{ selectedOrderHistory?.currency }} {{ selectedOrderHistory?.total_price | number }}</dd>
              </div>
              <div class="od-fact">
                <dt>{{ "Payment Type" | translate }}</dt>
                <dd>{{ (getPaymentType(selectedOrderHistory?.payment_type)?.display | translate) || "-" }}</dd>
              </div>
              <div class="od-fact">
                <dt>{{ "Order Date" | translate }}</dt>
                <dd>{{ selectedOrderHistory?.created | date: "medium" }}</dd>
              </div>
            </dl>

            <div class="od-grid">
              <!-- Delivery -->
              <section class="od-panel">
                <h3 class="od-panel-title">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                      fill="currentColor" />
                  </svg>
                  {{ "Delivery Details" | translate }}
                </h3>
                <p class="od-name">{{ selectedOrderHistory?.receiver_name }}</p>
                <p class="od-address">{{ selectedOrderHistory?.receiver_address }}</p>
                <a class="od-phone" href="tel:{{ selectedOrderHistory?.receiver_mobile }}" *ngIf="selectedOrderHistory?.receiver_mobile">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                      fill="currentColor" />
                  </svg>
                  {{ selectedOrderHistory?.receiver_mobile }}
                </a>
              </section>

              <!-- Courier -->
              <section class="od-panel">
                <h3 class="od-panel-title">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm1.5-9H17V12h4.46L19.5 9.5zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3zM3 6v9h.76c.55-.61 1.35-1 2.24-1s1.69.39 2.24 1H15V6H3z"
                      fill="currentColor" />
                  </svg>
                  {{ "Courier Details" | translate }}
                </h3>
                <dl class="od-rows">
                  <div class="od-row">
                    <dt>{{ "Courier" | translate }}</dt>
                    <dd>{{ selectedOrderHistory?.courier_name || "-" }}</dd>
                  </div>
                  <div class="od-row">
                    <dt>{{ "Shipping Fee" | translate }}</dt>
                    <dd>
                      <ng-container *ngIf="selectedOrderHistory?.courier_charges !== '' && selectedOrderHistory?.courier_charges != null; else noShippingFee">
                        {{ selectedOrderHistory?.currency }} {{ selectedOrderHistory?.courier_charges }}
                      </ng-container>
                      <ng-template #noShippingFee>-</ng-template>
                    </dd>
                  </div>
                  <div class="od-row" *ngIf="selectedOrderHistory?.tracking_code">
                    <dt>{{ "Tracking Code" | translate }}</dt>
                    <dd class="od-mono">{{ selectedOrderHistory?.tracking_code }}</dd>
                  </div>
                  <div class="od-row" *ngIf="isReferralExist && orderReferralExist">
                    <dt>{{ "Referral Code" | translate }}</dt>
                    <dd>{{ selectedOrderHistory?.referral_code }}</dd>
                  </div>
                  <div class="od-row" *ngIf="isReferralExist && orderReferralLinkExist">
                    <dt>{{ "Referral Link" | translate }}</dt>
                    <dd class="od-break">{{ selectedOrderHistory?.referral_from_url }}</dd>
                  </div>
                </dl>
              </section>
            </div>

            <!-- Installment -->
            <section class="od-panel" *ngIf="selectedOrderHistory?.payment_type === 'installment'">
              <h3 class="od-panel-title">{{ "Installment Details" | translate }}</h3>
              <dl class="od-rows">
                <div class="od-row">
                  <dt>{{ "Installment Period" | translate }}</dt>
                  <dd>
                    {{
                      selectedOrderHistory.installment_type == 0
                        ? ("Pending" | translate)
                        : selectedOrderHistory.installment_type + " " + ("Months" | translate)
                    }}
                  </dd>
                </div>
              </dl>
            </section>

            <!-- Cancel reason -->
            <section class="od-panel od-panel-danger"
              *ngIf="isSubsOrCOD(selectedOrderHistory.payment_status) && selectedOrderHistory.cancel_reason !== ''">
              <h3 class="od-panel-title">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                    fill="currentColor" />
                </svg>
                {{ "Cancel Reason" | translate }}
              </h3>
              <p class="od-text">{{ selectedOrderHistory.cancel_reason }}</p>
            </section>

            <!-- Express checkout link -->
            <section class="od-panel"
              *ngIf="!emptyCheckoutLinkDetails(selectedOrderHistory?.checkout_link_details) || selectedOrderHistory?.checkout_link_url != ''">
              <h3 class="od-panel-title">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path
                    d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                    fill="currentColor" />
                </svg>
                {{ "Express Checkout Link" | translate }}
              </h3>
              <a class="od-link" [href]="getCheckoutUrl(selectedOrderHistory?.checkout_link_details)"
                *ngIf="selectedOrderHistory?.checkout_link_details?.url" target="_blank">
                {{ getCheckoutUrl(selectedOrderHistory?.checkout_link_details) }}
              </a>
              <a class="od-link" [href]="selectedOrderHistory?.checkout_link_url"
                *ngIf="selectedOrderHistory?.checkout_link_url != ''" target="_blank">
                <span class="od-link-title">({{ selectedOrderHistory?.checkout_link_title }})</span>
                {{ selectedOrderHistory?.checkout_link_url }}
              </a>
              <span class="od-muted"
                *ngIf="!selectedOrderHistory?.checkout_link_details?.url && selectedOrderHistory?.checkout_link_url == ''">
                {{ "Checkout link not available" | translate }}
              </span>
            </section>

            <!-- Payment link (orders still waiting for payment) -->
            <section class="od-panel"
              *ngIf="selectedOrderHistory?.fiv5s_order_response?.link && selectedOrderHistory.status?.toLowerCase() === 'pending payment'">
              <h3 class="od-panel-title">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path
                    d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                    fill="currentColor" />
                </svg>
                {{ "Payment Link" | translate }}
              </h3>
              <div class="od-payment-link">
                <span class="od-link od-break">{{ selectedOrderHistory?.fiv5s_order_response?.link }}</span>
                <div class="od-payment-actions">
                  <a class="od-btn" target="_blank"
                    [href]="selectedOrderHistory?.fiv5s_order_response?.link +
                      '/otp/' +
                      selectedOrderHistory.fiv5s_order_response.otp +
                      '/successUrl/' +
                      successUrl +
                      '/returnUrl/' +
                      returnUrl"
                    matTooltip="{{ 'Open in new tab' | translate }}"
                    matTooltipPosition="above">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" fill="currentColor" />
                    </svg>
                    <span>{{ "Open" | translate }}</span>
                  </a>
                  <button type="button" class="od-btn od-btn-primary"
                    (click)="utils.copyToClipboard(
                      selectedOrderHistory?.fiv5s_order_response?.link +
                        '/otp/' +
                        selectedOrderHistory.fiv5s_order_response.otp +
                        '/successUrl/' +
                        successUrl +
                        '/returnUrl/' +
                        returnUrl,
                      'Payment Link'
                    )"
                    matTooltip="{{ 'Copy to clipboard' | translate }}"
                    matTooltipPosition="above">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor" />
                    </svg>
                    <span>{{ "Copy" | translate }}</span>
                  </button>
                </div>
              </div>
            </section>

            <!-- Products -->
            <ng-container
              *ngIf="(selectedOrderHistory?.fiv5s_order_response?.order_detail || selectedOrderHistory?.order_details || []) as products">
              <section class="od-panel od-products">
                <h3 class="od-panel-title">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path
                      d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                      fill="currentColor" />
                  </svg>
                  {{ "Product Details" | translate }}
                  <span class="od-count" *ngIf="products.length">{{ products.length }}</span>
                </h3>
                <div class="od-product" *ngFor="let item of products">
                  <div class="od-product-main">
                    <img [src]="+item.data.is_subscription === 1 && +item.data.price > 0 ? item.data.subscription?.image : item.data.image" class="od-product-image" alt=""
                      onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';" />
                    <div class="od-product-info">
                      <p class="od-product-name">{{ +item.data.is_subscription === 1 && +item.data.price > 0 ? item.data.subscription?.title : item.data.product_name }}</p>
                      <p class="od-product-qty">{{ "Qty" | translate }}: {{ item.data.quantity }}</p>
                    </div>
                    <div class="od-product-price">
                      <span *ngIf="+item.data.price !== 0">{{ item.data.currency }} {{ +item.data.price | number }}</span>
                      <span class="od-free" *ngIf="+item.data.price === 0">{{ "Free" | translate }}</span>
                    </div>
                  </div>

                  <!-- Mixture products -->
                  <div class="od-mixture" *ngIf="item.mixture_product !== undefined">
                    <button type="button" class="od-mixture-toggle" [attr.aria-expanded]="!!selectedShowAll[item.data.p_id]"
                      (click)="toggleMixture(item.data.p_id)">
                      <span class="od-mixture-title">{{ "Mixture" | translate }}</span>
                      <span class="od-mixture-action">
                        {{ selectedShowAllText[item.data.p_id] }}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true" [class.rotated]="selectedShowAll[item.data.p_id]">
                          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" fill="currentColor" />
                        </svg>
                      </span>
                    </button>
                    <div class="od-mixture-list" *ngIf="selectedShowAll[item.data.p_id]">
                      <div *ngFor="let mixture_product of item.mixture_product" class="od-mixture-item">
                        <img [src]="mixture_product?.data?.image" class="od-mixture-image" alt=""
                          onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';" />
                        <span class="od-mixture-name">{{ resolveMixtureName(item, mixture_product) }}</span>
                        <span class="od-mixture-qty">&times; {{ mixture_product?.data?.quantity }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </ng-container>
          </ng-container>

          <!-- Subscription cycle -->
          <ng-container *ngIf="isCurrentDetailsTab(1)">
            <ol class="od-timeline">
              <li *ngFor="let orderHistory of selectedOrderHistory?.recurred_order; let i = index" class="od-cycle"
                [class.is-active]="i === 0 && isInDateRange(orderHistory)">
                <span class="od-cycle-dot" aria-hidden="true">
                  <svg *ngIf="i === 0 && isInDateRange(orderHistory)" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor" />
                  </svg>
                </span>
                <div class="od-cycle-body">
                  <div class="od-cycle-head">
                    <span class="od-cycle-dates">
                      {{ orderHistory.order_date | date : "mediumDate" }} – {{ orderHistory.next_renewal | date : "mediumDate" }}
                    </span>
                    <span class="od-cycle-badge" [class.is-active]="i === 0 && isInDateRange(orderHistory)">
                      <ng-container *ngIf="i === 0 && isInDateRange(orderHistory)">{{ "Active" | translate }}</ng-container>
                      <ng-container *ngIf="i > 0 || !isInDateRange(orderHistory)">{{ "Ended" | translate }}</ng-container>
                    </span>
                  </div>
                  <p class="od-cycle-order">{{ "Order ID" | translate }}: <strong>{{ orderHistory.order_id }}</strong></p>
                </div>
              </li>
            </ol>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #rejectCodTemplate let-modal>
      <div class="modal-reject-cod-header">
        <h4 class="modal-title" id="modal-basic-title">
          {{ "Reject Order" | translate }}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-reject-cod-body">
        <div class="text-subtitle mb-2 required">
          {{ "Rejection reason" | translate }}
        </div>
        <div class="form-group">
          <textarea class="form-control" rows="4" [(ngModel)]="remark"
            [ngClass]="{ 'form-control-error': remarkError && remark === '' }" placeholder="{{
              'Please enter reason for cancellation' | translate
            }}"></textarea>
          <span *ngIf="remarkError && remark === ''" style="color: #eb5757; font-size: 12px">{{ "Please indicate your reason to proceed." | translate }}
          </span>
        </div>
      </div>
      <div class="modal-reject-cod-footer">
        <button type="button" class="btn reject-cancel" (click)="modal.close('cancel')">
          {{ "Cancel" | translate }}
        </button>
        <button type="button" class="btn reject-confirm" (click)="onUpdateClick(modal)">
          {{ "Reject" | translate }}
        </button>
      </div>
    </ng-template>
</div>